import { Box, CircularProgress, Grid } from '@mui/material';
import { DimensionVideoListModel } from '../models/DimensionVideoListModel';
import { IntroVideoCard } from './IntroVideoCard';
import {
  Routes,
  useIntersectionObserver,
  useLanguage,
} from '@xolv-mybrightlink/common';
import { useCallback, useRef } from 'react';
import DimensionVideoCard from './DimensionVideoCard';
import { useDimensionClass } from '../hooks/useDimensionClass';
import { loadNextPage } from '../hooks/useDimensionClassAction';
import { DimensionClassStateType } from '../hooks/useDimensionClassReducer';
import { useNavigate } from 'react-router';
interface DimensionClassListProps {
  videoList: DimensionVideoListModel;
}
export const DimensionClassList = (props: DimensionClassListProps) => {
  const lastItemRef = useRef<HTMLDivElement>(null);
  let pageNumber = 1;
  const lang = useLanguage();
  const [state, dispatch] = useDimensionClass();
  const navigate = useNavigate();

  useIntersectionObserver(lastItemRef, () => {
    if (
      state.currentState === DimensionClassStateType.LOADED &&
      state.videoList?.hasMore
    ) {
      pageNumber++;
      loadNextPage(dispatch, pageNumber, lang.language);
    }
  });

  const openDimensionDetails = useCallback(
    (postId: number, postTitle: string) => {
      navigate(Routes.resources.dimensions.postId(postId), {
        state: {
          postTitle: postTitle,
          postId: postId,
        },
      });
    },
    [navigate],
  );

  return (
    <Box>
      <Grid
        container
        spacing={{ xs: 1, sm: 3, md: 10 }}
        columns={{ xs: 1, sm: 2, md: 8, lg: 12, xl: 16 }}
      >
        <Grid
          item
          xs={1}
          sm={2}
          md={4}
          lg={4}
          xl={4}
          key={props.videoList.introductionPost.title}
        >
          <IntroVideoCard
            title={props.videoList.introductionPost.title}
            imageSrc={'/public/assets/images/dimension_intro.png'}
            onItemClicked={() =>
              openDimensionDetails(
                props.videoList.introductionPost.id,
                props.videoList.introductionPost.title,
              )
            }
          />
        </Grid>
        {props.videoList.videos.map((video, index) => (
          <Grid
            item
            xs={1}
            sm={2}
            md={4}
            lg={4}
            xl={4}
            key={video.title + index}
          >
            <DimensionVideoCard
              video={video}
              ref={
                index === props.videoList.videos.length - 1 ? lastItemRef : null
              }
              onItemClicked={() =>
                openDimensionDetails(video.wpPostId, video.title)
              }
            />
          </Grid>
        ))}
      </Grid>
      {state.currentState === DimensionClassStateType.LOAD_MORE && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            pt: 10,
            pb: 10,
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};
